import React from "react";
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import isWindow from 'components/common/helpers/isWindow';

class Seo extends React.Component {
  componentDidMount() {
    this.renderMetaTags();
  }

  componentDidUpdate() {
    this.renderMetaTags();
  }

  renderMetaTags = () => {
    if (!isWindow) return;

    var { title, ...othersMeta } = this.props.seo;
    var items = document.querySelectorAll("head [data-page]");
    for (var i = 0; i < items.length; i++) {
      items[i].parentNode.removeChild(items[i]);
    }

    if (title) {
      document.title = title;
    }

    for (var objMeta in othersMeta) {
      this.buildMetas(objMeta, othersMeta[objMeta]);
    }
  }

  buildMetas = (key, value) => {
    var head = document.getElementsByTagName('head')[0];
    var meta = null;
    switch (key) {
      case "description":
        meta = document.createElement('meta');
        meta.name = "description";
        meta.content = value;
        break;
      case "keywords":
        meta = document.createElement('meta');
        meta.name = "keywords";
        meta.content = value;
        break;
      case "author":
        meta = document.createElement('meta');
        meta.name = "author";
        meta.content = value;
        break;
      case "application_name":
        meta = document.createElement('meta');
        meta.name = "application-name";
        meta.content = value;
        break;
      case "fb_title":
        meta = document.createElement('meta');
        meta.setAttribute('property', 'og:title');
        meta.content = value;
        break;
      case "fb_type":
        meta = document.createElement('meta');
        meta.setAttribute('property', 'og:type');
        meta.content = value;
        break;
      case "fb_image":
        meta = document.createElement('meta');
        meta.setAttribute('property', 'og:image');
        meta.content = value;
        break;
      case "fb_url":
        meta = document.createElement('meta');
        meta.setAttribute('property', 'og:url');
        meta.content = value;
        break;
      case "fb_description":
        meta = document.createElement('meta');
        meta.setAttribute('property', 'og:description');
        meta.content = value;
        break;
    }

    if (meta && head) {
      meta.dataset.page = "1";
      head.appendChild(meta);
    }
  }

  render() {
    return (null);
  }
}

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};

function mapStateToProps(state) {
  return {
    seo: state.app.seo
  }
}

export default connect(mapStateToProps)(Seo);
